import { ObservableQuery, OperationVariables } from '@apollo/client';

export const wait = (ms: number | undefined = 0) => new Promise((res) => setTimeout(res, ms));
export const delayRefetchedQuery = async ({
  observableQuery,
  delay = 500
}: {
  observableQuery: ObservableQuery<any, OperationVariables>;
  delay?: number;
}) => {
  await wait(delay);
  observableQuery.refetch();
};
